import React, { ReactElement } from 'react';
import Image from 'next/image';
import Container from '@components/ui/container';
import { ASSET_URL } from 'lib/constants';

export default function LargeHeroImage(block: any): ReactElement {
  const { image, options } = block;
  const { className, variant = 'default' } = options;

  return (
    <Container>
      <div className="group w-full relative mt-8 mb-4">
        {variant === 'default' && (
          <>
            <div className="z-10 absolute inset-0 bg-gradient-to-b from-telesoft to-transparent mix-blend-soft-light" />
            <Image
              src={ASSET_URL + '/' + image.filename}
              alt={image?.alt || ''}
              width={1920}
              height={700}
              className={`object-cover object-center group-hover:scale-105 bg-black transition-transform duration-1000 ${className}`}
            />
          </>
        )}

        {variant === 'product' && (
          <Image
            src={ASSET_URL + '/' + image.filename}
            alt={image?.alt || ''}
            width={1920}
            height={400}
            className={`object-contain object-center group-hover:scale-105 transition-transform duration-1000 ${className}`}
          />
        )}
      </div>
    </Container>
  );
}
